import { render, staticRenderFns } from "./SwitchTemplateGroup.vue?vue&type=template&id=fdb0f85a&scoped=true"
import script from "./SwitchTemplateGroup.vue?vue&type=script&lang=js"
export * from "./SwitchTemplateGroup.vue?vue&type=script&lang=js"
import style0 from "./SwitchTemplateGroup.vue?vue&type=style&index=0&id=fdb0f85a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb0f85a",
  null
  
)

export default component.exports